import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import boardService from 'services/board/board-service';
import { BOARD_INQUIRY_MODULE_NO } from 'data/constants';
import InquiryView from './InquiryView';

export function Inquiry(props) {
  const { langList } = useOutletContext();
  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const [agree, setAgree] = useState(false);
  const [inquiryList, setInquiryList] = useState([]);
  const [inquiryTotal, setInquiryTotal] = useState(0);

  const onChange = (val, name) => {
    setValues({ ...values, [name]: val });
  };

  const agreeCheck = (val, name, checked) => {
    if (checked) {
      setAgree(true);
    } else {
      setAgree(false);
    }
  };

  useEffect(() => {
    async function fetchInquiries() {
      try {
        const response = await boardService.listContents(BOARD_INQUIRY_MODULE_NO, 1, 8);

        if (response) {
          setInquiryTotal(response.total || 0);
          setInquiryList(response.rows || []);
        }
      } catch (e) {
        console.error(e);
      }
    }

    fetchInquiries();
  }, []);

  // api
  const submit = () => {
    navigate('/');
  };

  return (
    <InquiryView
      list={langList.inquiry}
      onChange={onChange}
      values={values}
      agree={agree}
      agreeCheck={agreeCheck}
      submit={submit}
      inquiryList={inquiryList}
      inquiryTotal={inquiryTotal}
    />
  );
}
